import React, { useState } from 'react'
import styled from 'styled-components'

import VideoImage from 'components/ListView/VideoImage'
import ReactPlayer from './VideoWrapper'

const Box = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 10;
  padding: 0.5rem;
`
const Button = styled.button`
  border: none;
  text-decoration: underline;
`

const PublicVideoView = ({ post, freeEnabled }) => {
  const [showPlayer, setShowPlayer] = useState(false)
  const onClick = e => setShowPlayer(true)
  if (post && post.videoId && showPlayer) {
    return (
      <ReactPlayer
        url={`https://www.vimeo.com/${post.videoId}`}
        width="100%"
        height="100%"
        controls
      />
    )
  }
  return (
    <>
      {freeEnabled && post && post.videoId && !showPlayer && (
        <div style={{ display: 'hidden' }}>
          <Box>
            Klikk her får å{' '}
            <Button onClick={onClick}>prøve denne videoen gratis</Button>
          </Box>
        </div>
      )}
      <VideoImage
        image={
          post && post.featuredImage.node.mediaDetails.sizes
            ? post.featuredImage.node.mediaDetails.sizes[0].sourceUrl
            : null
        }
        mb={2}
      />
    </>
  )
}

export default PublicVideoView
